type ThrottleOptions = {
  trailing?: boolean;
  leading?: boolean;
};

export function throttle<Args extends unknown[], ReturnType>(
  func: (...args: Args) => ReturnType,
  wait: number,
  options: ThrottleOptions = {leading: true, trailing: true},
): (...args: Args) => void {
  let lastCall = 0;
  let timeoutId: NodeJS.Timeout | null = null;
  let lastArgs: Args | null = null;

  const leading = options.leading !== false;
  const trailing = options.trailing !== false;

  return function throttled(...args: Args): void {
    const now = Date.now();
    const remaining = wait - (now - lastCall);

    lastArgs = args;

    if (remaining <= 0) {
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }

      lastCall = now;

      if (leading) {
        func(...args);
      }
      return;
    }

    if (timeoutId === null && trailing) {
      timeoutId = setTimeout(() => {
        lastCall = leading ? Date.now() : 0;
        timeoutId = null;

        if (lastArgs) {
          func(...lastArgs);
          lastArgs = null;
        }
      }, remaining);
    }
  };
}
